
    import './styles.scoped.css';
    export default {
  "content-wrapper": "awsui_content-wrapper_zycdx_1wsy1_93",
  "content-wrapper-refresh": "awsui_content-wrapper-refresh_zycdx_1wsy1_97",
  "content-wrapper-no-navigation-padding": "awsui_content-wrapper-no-navigation-padding_zycdx_1wsy1_100",
  "content-wrapper-no-tools-padding": "awsui_content-wrapper-no-tools-padding_zycdx_1wsy1_103",
  "content-wrapper-mobile": "awsui_content-wrapper-mobile_zycdx_1wsy1_106"
};
  